import graphql__761631dfb25202b63e56 from "./__generated__/AnalyticsDatumCardRow_analyticsDatum.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnalyticsDatumCardRow = props => {
  const { label, count } = props.analyticsDatum;

  return (
    <div className="analytics-datum-card-row d-flex flex-row align-items-center margin-bottom-xxs">
      <div className="margin-right-xs font-weight-bold text-metric badge bg-primary flex-1-base-auto padding-right-none padding-left-none text-center">
        {count}
      </div>
      <div className="flex-12">{label}</div>
    </div>
  );
};

export default createFragmentContainer(AnalyticsDatumCardRow, {
  analyticsDatum: graphql__761631dfb25202b63e56
});
